import { TextField } from "@mui/material";

export function IaxNumericField({tfonchange, tfvalue, tflabel, tfrequired}) {
  return (
    <TextField
      type="number"
      variant="filled"
      InputLabelProps={{ shrink: true }}
      color="secondary"
      label={tflabel}
      onChange={tfonchange}
      value={tfvalue}
      required={tfrequired}
      sx={{ mb: 4 }}
    />
  );
}
